import React, { useEffect } from 'react';
import styles from './Requisites.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Meta from './Meta';

export function Requisites() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true }); 
  }, []);

  const okvedList = [
    { code: "28.23", desc: "Производство офисной техники и оборудования (кроме компьютеров и периферийного оборудования)" },
    { code: "43.2", desc: "Производство электромонтажных, санитарно-технических и прочих строительно-монтажных работ" },
    { code: "43.21", desc: "Производство электромонтажных работ" },
    { code: "43.22", desc: "Производство санитарно-технических работ, монтаж отопительных систем и систем кондиционирования воздуха" },
    { code: "43.3", desc: "Работы строительные отделочные" },
    { code: "45.2", desc: "Техническое обслуживание и ремонт автотранспортных средств" },
    { code: "45.3", desc: "Торговля автомобильными деталями, узлами и принадлежностями" },
    { code: "46.1", desc: "Торговля оптовая за вознаграждение или на договорной основе" },
    { code: "46.14.1", desc: "Деятельность агентов по оптовой торговле вычислительной техникой, телекоммуникационным оборудованием и прочим офисным оборудованием" },
    { code: "46.15", desc: "Деятельность агентов по оптовой торговле мебелью, бытовыми товарами, скобяными, ножевыми и прочими металлическими изделиями" },
    { code: "46.43", desc: "Торговля оптовая бытовыми электротоварами" },
    { code: "46.43.4", desc: "Торговля оптовая фототоварами и оптическими товарами" },
    { code: "46.66", desc: "Торговля оптовая прочей офисной техникой и оборудованием" },
    { code: "46.69", desc: "Торговля оптовая прочими машинами и оборудованием" },
    { code: "46.9", desc: "Торговля оптовая неспециализированная" },
    { code: "47.41", desc: "Торговля розничная компьютерами, периферийными устройствами к ним и программным обеспечением в специализированных магазинах" },
    { code: "47.41.4", desc: "Торговля розничная офисными машинами и оборудованием в специализированных магазинах" },
    { code: "47.43", desc: "Торговля розничная аудио- и видеотехникой в специализированных магазинах" },
    { code: "47.54", desc: "Торговля розничная бытовыми электротоварами в специализированных магазинах" },
    { code: "47.78.1", desc: "Торговля розничная фотоаппаратурой, оптическими приборами и средствами измерений, кроме очков, в специализированных магазинах" },
    { code: "47.91", desc: "Торговля розничная по почте или по информационно-коммуникационной сети Интернет" },
    { code: "47.91.1", desc: "Торговля розничная по почте" },
    { code: "47.91.2", desc: "Торговля розничная, осуществляемая непосредственно при помощи информационно-коммуникационной сети Интернет" },
    { code: "47.91.3", desc: "Торговля розничная через Интернет-аукционы" },
    { code: "47.91.4", desc: "Торговля розничная, осуществляемая непосредственно при помощи телевидения, радио, телефона" },
    { code: "53.20.31", desc: "Деятельность по курьерской доставке различными видами транспорта" },
    { code: "61.1", desc: "Деятельность в области связи на базе проводных технологий" },
    { code: "61.10", desc: "Деятельность в области связи на базе проводных технологий" },
    { code: "61.10.1", desc: "Деятельность по предоставлению услуг телефонной связи" },
    { code: "61.10.2", desc: "Деятельность по предоставлению услуг по передаче данных для целей передачи голосовой информации (IР-телефония)" },
    { code: "61.10.3", desc: "Деятельность по предоставлению услуг по передаче данных и услуг доступа к информационно-коммуникационной сети Интернет" },
    { code: "61.10.4", desc: "Деятельность в области документальной электросвязи" },
    { code: "61.10.5", desc: "Деятельность по трансляции телерадиоканалов по сетям кабельного телерадиовещания" },
    { code: "61.10.6", desc: "Деятельность операторов связи по присоединению и пропуску трафика" },
    { code: "61.10.8", desc: "Деятельность операторов связи по присоединению и пропуску международного трафика" },
    { code: "61.10.9", desc: "Деятельность в области связи на базе проводных технологий прочая" },
    { code: "61.20", desc: "Деятельность в области связи на базе беспроводных технологий" },
    { code: "61.20.1", desc: "Деятельность по предоставлению услуг подвижной связи для целей передачи голоса" },
    { code: "61.20.2", desc: "Деятельность по предоставлению услуг подвижной связи для целей передачи данных" },
    { code: "61.20.3", desc: "Деятельность по предоставлению услуг подвижной связи для доступа к информационно-коммуникационной сети Интернет" },
    { code: "61.20.4", desc: "Деятельность по предоставлению услуг связи для целей открытого эфирного вещания" },
    { code: "61.20.5", desc: "Деятельность по предоставлению услуг цифрового телерадиовещания на базе беспроводных технологий" },
    { code: "61.30", desc: "Деятельность в области спутниковой связи" },
    { code: "61.30.1", desc: "Деятельность по предоставлению услуг доступа к информационно-коммуникационной сети Интернет оператором спутниковой связи" },
    { code: "61.30.2", desc: "Деятельность по предоставлению услуг трансляции телерадиоканалов по сетям спутникового телерадиовещания" },
    { code: "61.90", desc: "Деятельность в области телекоммуникаций прочая" },
    { code: "62.0", desc: "Разработка компьютерного программного обеспечения, консультационные услуги в данной области и другие сопутствующие услуги" },
    { code: "62.01", desc: "Разработка компьютерного программного обеспечения" },
    { code: "62.02", desc: "Деятельность консультативная и работы в области компьютерных технологий" },
    { code: "62.02.1", desc: "Деятельность по планированию, проектированию компьютерных систем" },
    { code: "62.02.2", desc: "Деятельность по обследованию и экспертизе компьютерных систем" },
    { code: "62.02.3", desc: "Деятельность по обучению пользователей" },
    { code: "62.02.4", desc: "Деятельность по подготовке компьютерных систем к эксплуатации" },
    { code: "62.02.9", desc: "Деятельность консультативная в области компьютерных технологий прочая" },
    { code: "62.03", desc: "Деятельность по управлению компьютерным оборудованием" },
    { code: "62.03.1", desc: "Деятельность по управлению компьютерными системами" },
    { code: "62.03.11", desc: "Деятельность по управлению компьютерными системами непосредственно" },
    { code: "62.03.12", desc: "Деятельность по управлению компьютерными системами дистанционно" },
    { code: "62.03.13", desc: "Деятельность по сопровождению компьютерных систем" },
    { code: "62.03.19", desc: "Деятельность по управлению компьютерным оборудованием прочая, не включенная в другие группировки" },
    { code: "62.09", desc: "Деятельность, связанная с использованием вычислительной техники и информационных технологий, прочая" },
    { code: "63.1", desc: "Деятельность по обработке данных, предоставление услуг по размещению информации, деятельность порталов в информационно-коммуникационной сети Интернет" },
    { code: "63.11.1", desc: "Деятельность по созданию и использованию баз данных и информационных ресурсов" },
    { code: "63.91", desc: "Деятельность информационных агентств" },
    { code: "69", desc: "Деятельность в области права и бухгалтерского учета" },
    { code: "71.12.1", desc: "Деятельность, связанная с инженерно-техническим проектированием, управлением проектами строительства, выполнением строительного контроля и авторского надзора" },
    { code: "71.12.12", desc: "Разработка проектов промышленных процессов и производств, относящихся к электротехнике, электронной технике, горному делу, химической технологии, машиностроению, а также в области промышленного строительства, системотехники и техники безопасности" },
    { code: "71.12.13", desc: "Разработка проектов по кондиционированию воздуха, холодильной технике, санитарной технике и мониторингу загрязнения окружающей среды, строительной акустике" },
    { code: "73.1", desc: "Деятельность рекламная" },
    { code: "74.20", desc: "Деятельность в области фотографии" },
    { code: "77.33", desc: "Аренда и лизинг офисных машин и оборудования, включая вычислительную технику" },
    { code: "77.39.24", desc: "Аренда и лизинг профессиональной радио- и телевизионной аппаратуры и аппаратуры связи" },
    { code: "78.1", desc: "Деятельность агентств по подбору персонала" },
    { code: "82.92", desc: "Деятельность по упаковыванию товаров" },
    { code: "85.42", desc: "Образование профессиональное дополнительное" },
    { code: "95.1", desc: "Ремонт компьютеров и коммуникационного оборудования" },
    { code: "95.11", desc: "Ремонт компьютеров и периферийного компьютерного оборудования" },
    { code: "95.12", desc: "Ремонт коммуникационного оборудования" },
    { code: "95.22.1", desc: "Ремонт бытовой техники" },
    { code: "95.29", desc: "Ремонт прочих предметов личного потребления и бытовых товаров" }
  ];

  return (
      <React.Fragment>
      <Meta
         title="Официальные реквизиты компании-провайдера «ИТ Особа»"
         description="Реквизиты компании и партнера."
       />
    <div className={styles.requisitesContainer} data-aos="fade-up">
      <h2 data-aos="fade-down">Реквизиты компании:</h2>

      <p data-aos="fade-up" data-aos-delay="100"><strong>Общество с ограниченной ответственностью «ИТ Особа»</strong></p>
      <p data-aos="fade-up" data-aos-delay="200">Адрес: 142115, Московская область, г. Подольск, ул. Правды, д. 28</p>
      <p data-aos="fade-up" data-aos-delay="300">Телефон: 8 (499) 403-31-48</p>
      <p data-aos="fade-up" data-aos-delay="400">Веб-сайт: <a href="https://www.itosoba.net" target="_blank" rel="noopener noreferrer">www.itosoba.net</a></p>
      <p data-aos="fade-up" data-aos-delay="500">E-mail: <a href="mailto:info@itosoba.ru">info@itosoba.ru</a></p>

      <h3 data-aos="fade-down" data-aos-delay="600">Адреса и платежные реквизиты</h3>

      <div className={styles.tableWrapper} data-aos="zoom-in" data-aos-delay="700">
        <table className={styles.requisitesTable}>
          <tbody>
            <tr>
              <td><strong>Юридический адрес:</strong></td>
              <td>142115, Московская область, г. Подольск, ул. Правды, д. 28, корпус Главный, помещение № 26</td>
            </tr>
            <tr>
              <td><strong>Фактический адрес:</strong></td>
              <td>142115, Московская область, г. Подольск, ул. Правды, д. 28, корпус Главный, помещение № 26</td>
            </tr>
            <tr>
              <td><strong>Почтовый адрес:</strong></td>
              <td>142108, Московская область, г. Подольск, ул. Бородинский б-р, д. 15, а/я 259</td>
            </tr>
            <tr>
              <td><strong>ИНН/КПП:</strong></td>
              <td>5036096263 / 503601001</td>
            </tr>
            <tr>
              <td><strong>Р/с №:</strong></td>
              <td>4070 2810 9600 0000 3525 в Филиал «Центральный» Банка ВТБ (ПАО) г. Москва</td>
            </tr>
            <tr>
              <td><strong>К/с №:</strong></td>
              <td>3010 1810 1452 5000 0411</td>
            </tr>
            <tr>
              <td><strong>БИК:</strong></td>
              <td>044525411</td>
            </tr>
            <tr>
              <td><strong>ОГРН:</strong></td>
              <td>1095074001110</td>
            </tr>
            <tr>
              <td><strong>ОКПО:</strong></td>
              <td>88901366</td>
            </tr>
            <tr>
              <td><strong>ОКАТО:</strong></td>
              <td>46460000000</td>
            </tr>
            <tr>
              <td><strong>ОКФС:</strong></td>
              <td>16 - Частная собственность</td>
            </tr>
            <tr>
              <td><strong>ОКОГУ:</strong></td>
              <td>4210014 - Организации, учрежденные юридическими лицами или гражданами, или юридическими лицами и гражданами совместно</td>
            </tr>
            <tr>
              <td><strong>ОКОПФ:</strong></td>
              <td>12300 - Общества с ограниченной ответственностью</td>
            </tr>
            <tr>
              <td><strong>ОКТМО:</strong></td>
              <td>46760000001</td>
            </tr>
            <tr>
              <td><strong>Генеральный директор:</strong></td>
              <td>Плотников Александр Евгеньевич</td>
            </tr>
            <tr>
              <td><strong>Главный бухгалтер:</strong></td>
              <td>Плотникова Валентина Николаевна</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 data-aos="fade-down" style={{ marginTop: '80px' }}>Реквизиты партнера:</h2>
      
      <p data-aos="fade-up" data-aos-delay="100"><strong>Индивидуальный предприниматель Павлова Екатерина Александровна</strong></p>
      <p data-aos="fade-up" data-aos-delay="200">Адрес: 142115, МО, г. Подольск, ул. Правды, д.28</p>
      <p data-aos="fade-up" data-aos-delay="300">Телефон: 8 (925) 313-40-40</p>
      <p data-aos="fade-up" data-aos-delay="400">E-mail: <a href="mailto:zakaz@3d-med.ru">zakaz@3d-med.ru</a></p>

      <h3 data-aos="fade-down" data-aos-delay="500">Адреса и платежные реквизиты</h3>

      <div className={styles.tableWrapper} data-aos="zoom-in" data-aos-delay="600">
        <table className={styles.requisitesTable}>
          <tbody>
            <tr>
              <td><strong>Юридический адрес:</strong></td>
              <td>142121, Московская область, г Подольск, проезд Ленинградский, д. 7, кв. 114</td>
            </tr>
            <tr>
              <td><strong>Фактический адрес:</strong></td>
              <td>142115, МО, г. Подольск, ул. Правды, д.28</td>
            </tr>
            <tr>
              <td><strong>ИНН:</strong></td>
              <td>503613778254</td>
            </tr>
            <tr>
              <td><strong>ОГРНИП:</strong></td>
              <td>324508100357535</td>
            </tr>
            <tr>
              <td><strong>Р/с №:</strong></td>
              <td>4080 2810 5020 9000 7937</td>
            </tr>
            <tr>
              <td><strong>Банк:</strong></td>
              <td>АО "АЛЬФА-БАНК" г. Москва</td>
            </tr>
            <tr>
              <td><strong>К/с №:</strong></td>
              <td>3010 1810 2000 0000 0593</td>
            </tr>
            <tr>
              <td><strong>БИК:</strong></td>
              <td>044525593</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 data-aos="fade-down" style={{ marginTop: '80px' }}>Виды деятельности по ОКВЭД:</h2>
      <div className={styles.tableWrapper} data-aos="zoom-in" data-aos-delay="200">
        <table className={styles.requisitesTable}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '12px', borderBottom: '2px solid #ccc', backgroundColor: '#f0f0f0', color: '#0056b3' }}>Код ОКВЭД</th>
              <th style={{ textAlign: 'left', padding: '12px', borderBottom: '2px solid #ccc', backgroundColor: '#f0f0f0', color: '#0056b3' }}>Наименование вида деятельности</th>
            </tr>
          </thead>
          <tbody>
            {okvedList.map((item, index) => (
              <tr key={index}>
                <td style={{ fontWeight: '600', color: '#0056b3', width: '120px' }}>{item.code}</td>
                <td>{item.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
     </React.Fragment>
  );
}